import React from "react";
import useFilters from "hooks/useFilters";
import { SEARCH_RESULT_CATEGORY_NAMES } from "common/constants";
import { trackEvent, Category, Action } from "utils/trackEvent";
import classnames from "classnames";
import { SearchPageTypes } from "custom-types/Search";

type SearchFilterProps = {
  sortedCategories: SearchPageTypes[];
};

const SearchFilter = ({ sortedCategories }: SearchFilterProps) => {
  const { selectQueryValue, addQuery } = useFilters();
  const searchCategory = selectQueryValue("searchCategory");

  const handleClick = (e: React.MouseEvent<HTMLElement>) => {
    const value = e.currentTarget?.dataset?.value;
    addQuery({
      searchCategory: value,
    });

    trackEvent(
      Category.homepageSearch,
      Action.searchResultsFiltered,
      value || "All products"
    );
  };

  return (
    <>
      <h2 className="text-xs font-bold">Show me</h2>
      <div
        className={classnames(
          "flex lg:flex-wrap overflow-x-auto py-xs md:mt-none"
        )}
      >
        <button
          className={classnames(
            "flex-shrink-0 rounded-full px-sm mr-md mb-md text-xs font-bold",
            {
              "border border-light-grey pillText": !!searchCategory,
              "bg-green-40": !searchCategory,
            }
          )}
          data-value={null}
          onClick={handleClick}
          data-testid="search-filter-all"
        >
          All results
        </button>

        {sortedCategories.map((category) => {
          const active = searchCategory === category;

          return (
            <button
              key={category}
              className={classnames(
                "flex-shrink-0 rounded-full px-sm mr-md mb-md text-xs font-bold",
                {
                  "border border-light-grey pillText": !active,
                  "bg-green-40": active,
                }
              )}
              data-value={category}
              onClick={handleClick}
              data-testid={`search-filter-${category}`}
            >
              {SEARCH_RESULT_CATEGORY_NAMES[category] || category}
            </button>
          );
        })}
      </div>
      <style jsx>{`
        .pillText {
          color: var(--color-green);
        }
      `}</style>
    </>
  );
};

export default SearchFilter;
